// extracted by mini-css-extract-plugin
export default {"container":"gDmH7cnF","content":"QpoY4Mxk","icon":"ZNmBENSw","message":"c_ktHROT"};